function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 5,
  width: 52.011,
  height: 50.59,
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_688",
  "data-name": "Caminho 688",
  d: "M-3.858-1.074l59.283-3.67,8.469,57.59H-3.858l-2.259-3.388Z",
  transform: "translate(6.116 4.744)",
  fill: "#00abff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1472",
  "data-name": "Grupo 1472"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_682",
  "data-name": "Caminho 682",
  d: "M373.564,330.255a3.31,3.31,0,0,0-1.834-5.645l-10.98-1.6a.661.661,0,0,1-.5-.362l-4.91-9.949a3.31,3.31,0,0,0-5.935,0l-4.91,9.949a.664.664,0,0,1-.5.363l-10.979,1.6a3.309,3.309,0,0,0-1.834,5.645L339.129,338a.661.661,0,0,1,.19.586l-1.876,10.936a3.309,3.309,0,0,0,4.8,3.488l9.82-5.163a.661.661,0,0,1,.616,0l9.821,5.163a3.309,3.309,0,0,0,4.8-3.488l-1.876-10.936a.663.663,0,0,1,.19-.586Zm-10.745,8.778,1.875,10.936a.661.661,0,0,1-.96.7l-9.821-5.163a3.308,3.308,0,0,0-3.08,0l-9.821,5.163a.662.662,0,0,1-.96-.7l1.876-10.936a3.309,3.309,0,0,0-.952-2.929l-7.945-7.745a.662.662,0,0,1,.367-1.129l10.98-1.6a3.31,3.31,0,0,0,2.492-1.81l4.91-9.95a.662.662,0,0,1,1.187,0l4.91,9.95a3.308,3.308,0,0,0,2.492,1.81l10.98,1.6a.662.662,0,0,1,.367,1.129L363.77,336.1a3.308,3.308,0,0,0-.951,2.929Zm0,0",
  transform: "translate(-320.224 -305.271)",
  fill: "#0078d7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_683",
  "data-name": "Caminho 683",
  d: "M595.008,323.286a1.323,1.323,0,0,0-1.849.293l-1.4,1.934a1.324,1.324,0,1,0,2.141,1.556l1.405-1.934a1.324,1.324,0,0,0-.293-1.849Zm0,0",
  transform: "translate(-547.394 -315.855)",
  fill: "#00abff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1471",
  "data-name": "Grupo 1471",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_de_m\\xE1scara_1",
  "data-name": "Grupo de m\\xE1scara 1",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_684",
  "data-name": "Caminho 684",
  d: "M381.243,325.454l-1.405-1.934a1.324,1.324,0,0,0-2.141,1.556l1.4,1.934a1.324,1.324,0,1,0,2.142-1.556Zm0,0",
  transform: "translate(-361.309 -315.803)",
  fill: "#00abff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_685",
  "data-name": "Caminho 685",
  d: "M312.857,532.034a1.324,1.324,0,0,0-1.668-.85l-2.273.739a1.324,1.324,0,1,0,.818,2.518l2.274-.738a1.324,1.324,0,0,0,.85-1.668Zm0,0",
  transform: "translate(-300.941 -496.749)",
  fill: "#00abff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_686",
  "data-name": "Caminho 686",
  d: "M491.2,650.59a1.324,1.324,0,0,0-1.324,1.323V654.3a1.324,1.324,0,0,0,2.647,0v-2.391a1.324,1.324,0,0,0-1.324-1.323Zm0,0",
  transform: "translate(-459.048 -600.607)",
  fill: "#00abff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_687",
  "data-name": "Caminho 687",
  d: "M658.343,531.939l-2.273-.739a1.324,1.324,0,1,0-.818,2.518l2.273.739a1.324,1.324,0,0,0,.818-2.518Zm0,0",
  transform: "translate(-602.018 -496.762)",
  fill: "#00abff"
}))));

function SvgQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.011,
    height: 50.59,
    viewBox: "0 0 52.011 50.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_rolagem_1",
    "data-name": "Grupo de rolagem 1",
    transform: "translate(-6 -5)",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.9e43950f.svg";
export { ForwardRef as ReactComponent };